import { useCallback, useState } from 'react'

import { Routes } from 'common/constants'
import { useLocation, useNavigate } from 'react-router-dom'

const defaultTextContent = {
  downloadingMessage: 'Downloading file',
  errorMessage: 'Something went wrong trying to get the file.',
}

export const usePdfViewer = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const downloadingMessage =
    location.state?.downloadingMessage ?? defaultTextContent.downloadingMessage
  const errorMessage = location.state?.errorMessage ?? defaultTextContent.errorMessage

  const textContent = { downloadingMessage, errorMessage }

  const [totalPages, setTotalPages] = useState<number | undefined>()

  const onDocumentLoadSuccess = useCallback(({ numPages }: { numPages: number }) => {
    setTotalPages(numPages)
  }, [])

  const onDocumentLoadError = useCallback(() => {
    navigate(Routes.ERROR)
  }, [navigate])

  return {
    totalPages,
    textContent,
    onDocumentLoadSuccess,
    onDocumentLoadError,
  }
}
